import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'

export const getCatalogMaritalStatuses = async ({ commit }, params = '') => {
    try {
        const { data: result } = await configurationClient.get(`/catalog/marital-statuses${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextMaritalStatusKey = async ({ commit }) => {
    try {
        const { data: result } = await configurationClient.get(`/catalog/marital-statuses/next-key`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogMaritalStatus = async ({ commit }, payload) => {
    try {
        const { data: result } = await configurationClient.post(`/catalog/marital-statuses/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
